import { API_PATHS } from '@/constants/api-paths'
import { api } from '@/lib/api'

export interface RegisterFcmTokenPayload {
  token: string
  serviceInstanceId?: string | null
}

export const fcmNotificationsApi = {
  async registerToken({ token, serviceInstanceId }: RegisterFcmTokenPayload): Promise<void> {
    await api.post(API_PATHS.notifications.registerFcmToken, {
      fcm_token: token,
      device_type: 'web',
      ...(serviceInstanceId ? { service_instance_id: serviceInstanceId } : {}),
    })
  },
}
